import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './Sidebar.scss';
import { ICONS } from '../../common/constants';
import Avatar from '../../components/Avatar';
import Navigation from '../../components/Navigation';
import * as sidebar from '../../copy/sidebar';
import Tenant from '../../components/Tenant';
import Typeahead from './Typeahead';
import Wizard from '../../components/Wizard';
import 'react-image-lightbox/style.css';
import Icon from '../../components/Icon';
import classNames from 'classnames';
import { Images } from '../../Tenants';
import { checkUserPermission } from '../../helpers/validationHelper';
import Button1 from '../../components/Button/Button1';
import SuiteInfoHeader from '../../components/HomeOwnerDashboard/SuiteInfoHeader';
import {
  clearSelectedModulePermission,
  fetchtAllowedTabList,
} from '../../store/actions/tabSelections';
import { store } from '../../store';
import Loader from '../../components/Loader';
import ServiceRequestForm from '../../components/ServiceRequestForm/ServiceRequestForm';
import { selectServiceRequestFormIsVisible } from '../../store/selectors/serviceRequestForm';
import { setServiceRequestFormIsVisible } from '../../store/actions/serviceRequestForm';
import Overlay from '../../components/Overlay';
import { BrandingContext } from '../../branding/BrandingContextProvider';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';
const sideNavOption = [
  {
    localLabel: 'Announcements',
    label: 'Announcements',
    path: '/app/announcements',
    icon: 'bullhorn',
  },
];

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
      isOpen: false,
      logo: '',
      topLinks: [],
      bottomLinks: [],
      loader: false,
      ishomeOwnwerHasAcessButton: false,
    };
  }
  static contextType = BrandingContext;
  componentDidMount() {
    window.setTimeout(() => this.setSideMenu(), 200);
  }
  async componentDidUpdate(prevProps) {
    const { selectedUserSuite: prevselectedUserSuite } = prevProps;
    const { tabSelections: prevtabSelections } = prevProps;
    const { onboardingData: prevOnboardingData } = prevProps;
    const {
      selectedUserSuite,
      fetchtAllowedTabList,
      tabSelections,
      onboardingData,
      user,
    } = this.props;
    const userRole = user.roles[0].role.name;
    if (prevselectedUserSuite.propertyId !== selectedUserSuite.propertyId) {
      this.setState({ loader: true });
      fetchtAllowedTabList(selectedUserSuite.propertyId);
    }
    if (onboardingData.orders !== prevOnboardingData.orders) {
      this.setState({ loader: true });
      setTimeout(() => this.setSideMenu(), 3000);
    }
    if (
      prevtabSelections !== tabSelections &&
      prevselectedUserSuite.propertyId !== selectedUserSuite.propertyId
    ) {
      this.setSideMenu();
    }
    if (
      this.state.ishomeOwnwerHasAcessButton == false &&
      (userRole === 'Home Owner' || userRole === 'Occupant')
    ) {
      let selectedUserSuiteId = this.props.selectedUserSuite?.propertyId;
      let IsHomeOwnerProperties = store.getState().properties;
      if (IsHomeOwnerProperties.length > 0) {
        const homeOwnerpermissions = IsHomeOwnerProperties.filter(
          (x) => x.propertyId == selectedUserSuiteId
        );
        if (homeOwnerpermissions.length > 0) {
          if (homeOwnerpermissions[0].modulePermissions.length > 0) {
            let filterData = homeOwnerpermissions[0].modulePermissions.filter(
              (x) => x.name === 'Service Requests'
            );
            if (filterData.length > 0) {
              this.setState({ ishomeOwnwerHasAcessButton: true });
            }
          }
        }
      }
    }
  }

  setSideMenu = () => {
    const { user } = this.props;
    const { branding } = this.context;
    const { allowedTabList } = store.getState().tabSelections;
    const userRole = user.roles[0].role.name;
    const { orders } = store.getState().onboardingData;
    const showHomeownerDasboard = Object.keys(orders).length > 0 ? true : false;
    let topLinks;

    if (user.isDashboardAccess) {
      topLinks = sidebar
        .topLinks(branding)
        .filter((item, key) => item.label === 'Dashboard');
    } else {
      topLinks = sidebar.topLinks(branding);
    }
    let bottomLinks = sidebar.bottomLinks(branding);
    let links = [];
    let tenantName = localStorage.getItem('theme');
    topLinks.map((lk) => {
      if (checkUserPermission(lk.label, false, lk.id)) {
        links = [...links, lk];
      }
    });

    localStorage.removeItem('showHomeownerDasboardPage');
    if (user.isDashboardAccess === true) {
      localStorage.setItem('showHomeownerDasboardPage', showHomeownerDasboard);
    }

    if (
      (userRole === 'Super Admin' || userRole === 'Admin') &&
      tenantName === 'Juniper'
    ) {
    } else if (
      (userRole === 'Super Admin' ||
        userRole === 'Admin' ||
        userRole === 'Property Developer') &&
      tenantName !== 'Juniper'
    ) {
    } else {
      let index = bottomLinks.findIndex((nav) => nav.id === 'emailTemplates');
      if (index > -1) {
        bottomLinks.splice(index, 1);
      }
    }

    if (userRole === 'Admin' || userRole === 'Super Admin') {
      links = links.filter(
        (nav) =>
          nav.id !== 'dashboard' &&
          nav.id !== 'keyContacts' &&
          nav.id !== 'home'
      );
    }

    if (
      userRole !== 'Admin' &&
      userRole !== 'Super Admin' &&
      userRole !== 'Property Developer'
    ) {
      bottomLinks = bottomLinks.filter((nav) => nav.id !== 'emailTemplates');
    }

    let allowedNavOptions = allowedTabList.map((item) => {
      let tenantObj = sideNavOption.filter(
        (tn) => tn.localLabel === item.name
      )[0];
      return tenantObj;
    });

    let filterAllowedNavOptions = allowedNavOptions.filter(function (element) {
      return element !== undefined;
    });

    if (
      (userRole === 'Home Owner' || userRole === 'Realtor') &&
      user.isDashboardAccess === false
    ) {
      if (filterAllowedNavOptions.length > 0) {
        let localLink = filterAllowedNavOptions.map((item) => {
          if (item.localLabel === 'Announcements') {
            return item;
          }
        });
        Array.prototype.push.apply(links, localLink);
        const filteredLinks = links.reduce((acc, current) => {
          const x = acc.find((item) => item.label === current.label);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);
        let withoutDashboard;
        if (user.isDashboardAccess === true) {
          withoutDashboard = filteredLinks.filter(
            (item) => item.label === 'Dashboard'
          );
        } else {
          withoutDashboard = filteredLinks.filter((item) => item.label);
        }
        this.setState({
          topLinks: showHomeownerDasboard ? withoutDashboard : filteredLinks,
          bottomLinks: bottomLinks,
        });
        this.setState({ loader: false });
      } else {
        const withoutDashboard = links.filter(
          (item) => item.id !== 'dashboard'
        );
        this.setState({
          topLinks: showHomeownerDasboard ? links : withoutDashboard,
          bottomLinks: bottomLinks,
        });
        this.setState({ loader: false });
      }
    } else {
      if (user.isDashboardAccess === true) {
        links = links.filter((nav) => nav.id === 'dashboard');
        this.setState({ topLinks: links, bottomLinks: bottomLinks });
      } else {
        this.setState({ topLinks: links, bottomLinks: bottomLinks });
      }
      // this.setState({ topLinks: links, bottomLinks: bottomLinks});
      this.setState({ loader: false });
    }
  };
  render() {
    const {
      from,
      serviceRequest,
      user,
      collapsableSideBar,
      collapseSideBar,
      clearSelectedModulePermission,
      serviceRequestFormIsVisible,
      onSetServiceRequestFormIsVisible,
    } = this.props;
    let { isOpen } = this.state;
    return (
      <>
        {this.state.loader ? <Loader center={true} /> : null}
        <div
          className={classNames('sidebar__collapsableBar', {
            'sidebar__collapsableBar--collapsedSideBar': collapseSideBar,
          })}
        >
          <div
            onClick={() => collapsableSideBar()}
            className="sidebar__collapsableBar--Icon"
          >
            <Icon weight="solid" glyph="bars" />
          </div>
        </div>
        <div
          className={classNames('sidebar', {
            'sidebar--collapsed': collapseSideBar,
          })}
        >
          <div className="sidebar__top">
            <div
              className={classNames('sidebar__yield', {
                'sidebar__yield--collapseSideBar': collapseSideBar,
              })}
            >
              <div className="sidebar__tenant">
                <Tenant
                  headline={`${user.firstname} ${user.lastname}`}
                  strapline={user.tenant && user.tenant.name}
                  avatar={
                    <div
                      onClick={() =>
                        this.setState({
                          isOpen: user && user.profileImage ? true : false,
                        })
                      }
                    >
                      <Avatar
                        badge={ICONS[user.type]}
                        url={user.profileImage}
                      />
                      {isOpen && isOpen === true ? (
                        <ReusableLightbox
                          isOpen={this.state.isOpen}
                          onClose={() => this.setState({ isOpen: false })}
                          image={user.profileImage}
                        />
                      ) : null}
                    </div>
                  }
                />
                {(user.roles[0].role.name === 'Home Owner' ||
                  user.roles[0].role.name === 'Realtor' ||
                  user.roles[0].role.name === 'Occupant') &&
                  user.isDashboardAccess === false && (
                    <div style={{ marginTop: 20 }}>
                      <SuiteInfoHeader />
                    </div>
                  )}
                {(user.roles[0].role.name === 'Home Owner' ||
                  user.roles[0].role.name === 'Occupant') &&
                this.state.ishomeOwnwerHasAcessButton === true &&
                user.isDashboardAccess === false &&
                collapseSideBar === false ? (
                  <>
                    {user.roles[0].role.name !== 'Home Owner' &&
                      user.roles[0].role.name !== 'Realtor' &&
                      user.roles[0].role.name !== 'Occupant' &&
                      user.isDashboardAccess === false && (
                        <div className="sidebar__search">
                          <Typeahead />
                        </div>
                      )}
                    <Overlay
                      showOverlay={serviceRequestFormIsVisible}
                      content={
                        <ServiceRequestForm
                          propertyDisabled={this.props.propertyDisabled}
                          serviceRequest={serviceRequest}
                          from={from}
                        />
                      }
                    />
                    <Button1
                      label="Create Request"
                      color="purple"
                      block
                      style={{ padding: 10 }}
                      icon={<Icon glyph="wrench" weight="light" size="small" />}
                      onClick={() => onSetServiceRequestFormIsVisible(true)}
                    ></Button1>
                  </>
                ) : null}
              </div>
              {(user.roles[0].role.name === 'Admin' ||
                user.roles[0].role.name === 'Super Admin' ||
                user.roles[0].role.name === 'Property Developer') &&
              collapseSideBar === false &&
              user.isDashboardAccess === false ? (
                <>
                  <div className="sidebar__search">
                    <Typeahead />
                  </div>
                  <Wizard
                    onClose={() => this.setState({ showOverlay: false })}
                    showOverlay={this.state.showOverlay}
                  />
                  <Button1
                    label="NEW"
                    onClick={() =>
                      this.setState(
                        { showOverlay: true },
                        clearSelectedModulePermission(),
                        window.history.replaceState(
                          {},
                          null,
                          '/app/service-requests'
                        )
                      )
                    }
                    color="purple"
                    block
                  />
                </>
              ) : null}
            </div>
            <Navigation
              collapseSideBar={collapseSideBar}
              links={this.state.topLinks}
            />
            <div className="sidebar__spacer" />
            <Navigation
              collapseSideBar={collapseSideBar}
              links={this.state.bottomLinks}
            />
          </div>
          <div
            className={classNames('sidebar__bottom', {
              'sidebar__bottom--collapsed': collapseSideBar,
            })}
          >
            <div className="sidebar__brand">
              <div className="sidebar__logo">
                <img alt="juniper" src={Images.logo} height="18" />
              </div>
              <div className="sidebar__customer">
                {user.tenant && user.tenant.name}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  tabSelections: state.tabSelections,
  selectedUserSuite: state.userSuites.selectedUserSuite,
  onboardingData: state.onboardingData,
  properties: state.properties,
  serviceRequestFormIsVisible: selectServiceRequestFormIsVisible(state),
});

const maptDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSetServiceRequestFormIsVisible: setServiceRequestFormIsVisible,
      fetchtAllowedTabList,
      clearSelectedModulePermission,
    },
    dispatch
  );
export default connect(mapStateToProps, maptDispatchToProps)(Sidebar);
